import BamCommercialFamilyCodes from 'pages/BackOfficePage/BackOfficeCategories/BamCommercialFamilyCodes/BamCommercialFamilyCodes';

export default BamCommercialFamilyCodes;
